import { render, staticRenderFns } from "./SelectPointOnMap.vue?vue&type=template&id=6dd5964a&"
import script from "./SelectPointOnMap.vue?vue&type=script&lang=js&"
export * from "./SelectPointOnMap.vue?vue&type=script&lang=js&"
import style0 from "./SelectPointOnMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports